import { formatDateTime } from "../../../../utils/dateUtils";

export const MODAL_COLUMNS = [
  { key: "certificate_No", label: "Certificate Number" },
  { key: "client_Name", label: "Client Name" },
  { key: "customer_Name", label: "Customer Name" },
  { key: "imeI_No", label: "IMEI Number" },
  { key: "phoneNumber", label: "Phone Number" },
  { key: "plan_Name", label: "Plan Name" },
  { key: "plan_Purchase_Date", label: "Plan Purchage Date" },
  { key: "policy_End_Date", label: "Policy End Date" },
  { key: "policy_Start_Date", label: "Policy Start Date" },
  { key: "sumassured", label: "Sum Assured" },
];

export const useViewDetailsModal = (data) => {
  // Check if field is a date field
  const isDateField = (key) => {
    return key.toLowerCase().includes("date");
  };

  // Get formatted value
  const getFormattedValue = (col) => {
    const value = data[col.key];

    if (!value) return "N/A";

    // Format date fields
    if (isDateField(col.key)) {
      return formatDateTime(value);
    }

    return value;
  };

  const handleViewCertiButtonClick = (certificateUrl = null) => {
    return certificateUrl && window.open(certificateUrl, "_blank");
  };

  return {
    handleViewCertiButtonClick,
    getFormattedValue,
  };
};
